export enum Reference {

    downloadAppSection= "downloadAppSection",
    faqSection = "faqSection"

}
